const API_BASE = process.env.REACT_APP_API_URL || 'https://tool.estimateassistant.com';

/**
 * Profile/Settings Client
 * Handles user profile and company settings
 */

/**
 * Get user settings/profile
 * @param {function} getToken - Clerk getToken function
 * @returns {Promise<object>} User settings object
 */
export async function getUserSettings(getToken) {
  try {
    const token = await getToken();

    const response = await fetch(`${API_BASE}/api/v2/user/settings`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Failed to fetch settings' }));
      throw new Error(error.error || `HTTP ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Get settings error:', error);
    throw error;
  }
}

/**
 * Update user settings/profile
 * @param {function} getToken - Clerk getToken function
 * @param {object} settings - Settings object to update
 * @returns {Promise<object>} Updated settings object
 */
export async function updateUserSettings(getToken, settings) {
  try {
    const token = await getToken();

    const response = await fetch(`${API_BASE}/api/v2/user/settings`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(settings),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Failed to update settings' }));
      throw new Error(error.error || `HTTP ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Update settings error:', error);
    throw error;
  }
}

/**
 * Upload company logo
 * @param {function} getToken - Clerk getToken function
 * @param {File} file - Logo file to upload
 * @returns {Promise<object>} Object with logoUrl
 */
export async function uploadLogo(getToken, file) {
  try {
    const token = await getToken();

    const formData = new FormData();
    formData.append('logo', file);

    const response = await fetch(`${API_BASE}/api/v2/user/logo`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Failed to upload logo' }));
      throw new Error(error.error || `HTTP ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Upload logo error:', error);
    throw error;
  }
}
